import { purify } from './json';

class FetchError extends Error {
  constructor(url, res) {
    super(`Error fetching url ${url}`);
    this.url = url;
    this.res = res;
    this.name = 'FetchError';
  }
}

export const handleFetchError = error => {
  // Checking error content type before rejecting
  const contentType = error.res.headers.get('content-type');
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return error.res.json().then(
      jsError =>
        new Promise((_, reject) => {
          reject(jsError);
        })
    );
  } else {
    return new Promise((_, reject) => {
      reject(error);
    });
  }
};

export default function fetchUrl(url, params = {}) {
  return fetch(url, {
    credentials: 'same-origin',
    ...params,
  }).then(res => {
    if (res.status < 400) {
      return res;
    } else {
      throw new FetchError(url, res);
    }
  });
}

export const fetchJson = (url, params = {}) =>
  fetchUrl(url, {
    ...params,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(res => res.json(), handleFetchError);

export const post = (url, data, params = {}) =>
  fetchUrl(url, {
    ...params,
    method: 'POST',
    body: data,
  });

export const postJson = (url, data, params = {}) =>
  fetchJson(url, {
    ...params,
    method: 'POST',
    body: JSON.stringify(data, purify),
  });

export const putJson = (url, data, params = {}) =>
  fetchJson(url, {
    ...params,
    method: 'PUT',
    body: JSON.stringify(data, purify),
  });



// WEBPACK FOOTER //
// ./src/utils/fetch.js